import React from "react"
import { Field, useFormikContext } from "formik"
import { useOrder } from "context/order"
import { useLocale } from "context/locale"
import Button from "components/Button"
import TruckIcon from "icons/join/truck.svg"
import ShopIcon from "icons/join/shop.svg"

import StyledStepFirst from "./styles"

const StepFirst = () => {
  const { t } = useLocale()
  const { validateForm, errors, isValid } = useFormikContext()
  const { step, setStep, checkValidation } = useOrder()

  return (
    <div className="form-step" style={step !== 1 ? { display: "none" } : {}}>
      <StyledStepFirst>
        <h4 className="order-courier-form__subheader">
          {t("Choose how you want to hand over the parcel")}
        </h4>
        <div className="order-courier-form__info">
          <div className="order-courier-form__info-row">
            <div className="order-courier-form__info-col col-6">
              <p>
                {t(
                  "Instead of ordering a courier, you can deliver the cartons by yourself to the nearest DPD Pickup point. Remember that the weight of the parcel handed over at a DPD Pickup point cannot exceed 20 kg."
                )}
              </p>
            </div>
            <div className="order-courier-form__info-col col-6">
              <p>
                {t(
                  "If you can’t print out the shipping label, order a courier to your place. In such a case, one carton can weight up to 30 kg."
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="order-types__container">
          {errors?.order_type && (
            <p className="form-error">{errors.order_type}</p>
          )}
          <div className="order-types__wrapper">
            <label className="order-type" htmlFor="courier">
              <Field
                type="radio"
                name="order_type"
                id="courier"
                value="courier"
              />
              <div className="order-type__box">
                <div className="box-row">
                  <div className="box-icon">
                    <TruckIcon />
                  </div>
                  <div className="box-text">
                    <p>{t("I want the courier to pick up the parcel")}</p>
                  </div>
                </div>
              </div>
            </label>
            <label className="order-type" htmlFor="pick_up">
              <Field
                type="radio"
                name="order_type"
                id="pick_up"
                value="pick_up"
              />
              <div className="order-type__box">
                <div className="box-row">
                  <div className="box-icon">
                    <ShopIcon />
                  </div>
                  <div className="box-text">
                    <p>
                      {t(
                        "I will deliver the parcel to a DPD Pickup point myself"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>

        <div className="order-courier-form__cta">
          <span />
          <Button
            type="button"
            text={t("Next")}
            variant="next"
            disabled={!isValid}
            onClick={async () => {
              if (checkValidation(await validateForm())) {
                setStep(2)
              }
            }}
          />
        </div>
      </StyledStepFirst>
    </div>
  )
}
export default StepFirst
